export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9014.df55672b.jpg";